import React from "react"

import PrimaryGradientButton from "~components/shared/primary-gradient-button"
import { useIsMobile } from "~components/shared/todo-lib-react-components/hooks/use-is-mobile"
import useDisclosure from "~components/shared/todo-lib-react-components/use-disclosure"
import { useAuth } from "~utils/auth-hooks"
import SignInOrGuestModal from "~components/pages/listing/checkout/sign-in-or-guest-modal"
import COPY from "~config/copy-constants"

import { useCheckoutFlow } from "./checkout-flow/checkout-flow-provider"

export default function ContinueButton() {
    const { isAuthenticated } = useAuth()
    const { goToNextStep, isWidget } = useCheckoutFlow()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const isMobile = useIsMobile()
    const shouldGoToNextStep = isAuthenticated || isWidget

    return (
        <>
            <PrimaryGradientButton
                fullwidth={!isMobile}
                onClick={() => (shouldGoToNextStep ? goToNextStep() : onOpen())}
            >
                {COPY.CONTINUE_TO_CHECKOUT}
            </PrimaryGradientButton>
            <SignInOrGuestModal isOpen={isOpen} onClose={onClose} />
        </>
    )
}
